var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJrAcademyLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1662,
    height: 265,
    viewBox: "0 0 1662 265",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.758%",
    y1: "0%",
    x2: "1047.472%",
    y2: "50%",
    id: "cd7h5rzcbb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3B6F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.427%",
    y1: "0%",
    x2: "538.543%",
    y2: "100%",
    id: "gek3flkgmc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3B6F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.572%",
    y1: ".285%",
    x2: "1427.355%",
    y2: "50%",
    id: "msgsz17fje"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3B6F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-7.739%",
    x2: "50%",
    y2: "95.109%",
    id: "8ugsay59mg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3B6F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "4atnd95cih"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E6D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E3B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.418 191.725 0 74.965a15.443 15.443 0 0 1 7.486-13.291l100.841-60.62a7.319 7.319 0 0 1 7.487-.048L224.826 64.7a.112.112 0 0 1 .169.098l-.104 13.01a7.721 7.721 0 0 1-3.82 6.602l-97.257 56.926.003 118.895a15.405 15.405 0 0 1-18.335 2.035L8.035 204.982a15.443 15.443 0 0 1-7.617-13.257zM167.981 58.78l-90.448 49.53v111.988l25.68 16.231.138-114.165 89.024-51.545a1.972 1.972 0 0 0-.094-3.465l-17.094-8.685a7.721 7.721 0 0 0-7.206.111z",
    id: "vg953tds3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.996 64.6 2.419 16.145L124.71 140.81l.001 150.51L.567 217.889.047 66.167l103.304 56.198 11.81 6.461L224.996 64.6z",
    id: "ex35q64t0f"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m157.597 152.461 56.948-32.62a7.721 7.721 0 0 1 11.56 6.7v17.01a7.721 7.721 0 0 1-3.79 6.645l-56.948 33.7a7.721 7.721 0 0 1-11.653-6.646v-18.089a7.721 7.721 0 0 1 3.883-6.7z",
    fill: "#FF5656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.985 212.169 203.702 130 175 142.463l.63 77.27a7.721 7.721 0 0 0 11.59 6.62l12.912-7.475a7.721 7.721 0 0 0 3.853-6.71z",
    fill: "#FF5656"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.005)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j7uy8u2lsd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vg953tds3a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#cd7h5rzcbb)",
    xlinkHref: "#vg953tds3a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#gek3flkgmc)",
    xlinkHref: "#vg953tds3a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#j7uy8u2lsd)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#msgsz17fje)",
    xlinkHref: "#ex35q64t0f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#8ugsay59mg)",
    xlinkHref: "#ex35q64t0f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.178 64.723)",
    fill: "url(#4atnd95cih)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.94 94.408V2.41H64.16v90.592c0 8.169-1.675 14.094-5.027 17.777-3.353 3.682-7.979 5.524-13.878 5.524-4.962 0-9.487-1.24-13.577-3.716-4.09-2.478-8.146-5.926-12.168-10.345L0 123.936c4.827 5.758 10.962 10.713 18.403 14.864 7.442 4.151 16.66 6.227 27.656 6.227 7.375 0 14.146-1.038 20.314-3.114 6.168-2.075 11.431-5.222 15.79-9.44 4.357-4.219 7.743-9.475 10.156-15.769 2.414-6.294 3.62-13.726 3.62-22.296zm153.261 48.61-34.393-50.217c8.984-3.348 16.258-8.604 21.823-15.768 5.564-7.164 8.347-16.438 8.347-27.82v-.402c0-14.596-4.66-25.979-13.979-34.148C221.68 6.495 208.64 2.41 191.88 2.41h-64.362v140.608h30.974V98.024h24.337l30.17 44.994H249.2zm-35.6-92.198c0 6.026-2.045 10.846-6.134 14.462-4.09 3.616-9.956 5.424-17.6 5.424h-31.376V30.33h30.773c7.643 0 13.61 1.674 17.901 5.022 4.29 3.348 6.436 8.37 6.436 15.065v.402zm256.845 92.198L410.106 1.406h-28.56l-60.34 141.612h31.578l12.872-31.536h59.535l12.873 31.536h32.382zm-56.317-58.854h-37.41l18.705-45.597 18.705 45.597zm201.734 36.156-19.71-19.886c-5.498 5.089-11.03 9.106-16.594 12.052-5.564 2.946-12.37 4.42-20.414 4.42-6.034 0-11.566-1.173-16.594-3.516-5.028-2.343-9.319-5.524-12.872-9.541-3.554-4.018-6.336-8.705-8.347-14.061-2.011-5.356-3.017-11.048-3.017-17.074v-.402c0-6.026 1.006-11.683 3.017-16.973 2.011-5.29 4.827-9.943 8.447-13.96 3.62-4.018 7.945-7.164 12.973-9.441 5.029-2.276 10.493-3.415 16.393-3.415 7.106 0 13.509 1.406 19.208 4.218 5.698 2.813 11.296 6.696 16.794 11.65l19.71-22.697a82.888 82.888 0 0 0-10.458-8.838c-3.754-2.679-7.844-4.955-12.269-6.83s-9.353-3.348-14.783-4.42C571.917.537 565.916 0 559.346 0c-10.861 0-20.784 1.908-29.768 5.725-8.984 3.816-16.694 9.039-23.13 15.667-6.436 6.63-11.464 14.329-15.085 23.1-3.62 8.771-5.43 18.179-5.43 28.222v.402c0 10.043 1.81 19.484 5.43 28.322 3.62 8.839 8.649 16.505 15.085 23 6.436 6.494 14.08 11.617 22.93 15.366 8.849 3.75 18.436 5.624 28.76 5.624 6.84 0 13.007-.569 18.505-1.707 5.497-1.138 10.56-2.812 15.185-5.022 4.626-2.21 8.884-4.854 12.772-7.934 3.889-3.08 7.643-6.562 11.263-10.445zm161.911 22.698L717.434 1.406h-28.56l-60.34 141.612h31.578l12.873-31.536h59.535l12.872 31.536h32.382zm-56.317-58.854h-37.41l18.705-45.597 18.705 45.597zm207.769-11.45v-.402c0-9.909-1.81-19.115-5.43-27.619-3.621-8.503-8.75-15.902-15.387-22.196-6.638-6.294-14.549-11.215-23.734-14.764-9.185-3.548-19.275-5.323-30.27-5.323h-54.909v140.608h54.909c10.995 0 21.085-1.808 30.27-5.423 9.185-3.616 17.096-8.57 23.734-14.865 6.637-6.294 11.766-13.726 15.386-22.296 3.62-8.57 5.43-17.81 5.43-27.72zm-32.382.402c0 6.294-1.04 11.985-3.118 17.074-2.078 5.088-4.961 9.507-8.649 13.257-3.687 3.75-8.145 6.629-13.375 8.637-5.23 2.009-10.995 3.013-17.297 3.013H830.47V30.331h23.935c6.302 0 12.068 1.038 17.297 3.114 5.23 2.075 9.688 4.988 13.375 8.737 3.688 3.75 6.57 8.236 8.65 13.458 2.077 5.223 3.117 10.914 3.117 17.074v.402zm167.14 69.902v-27.519h-76.43V85.971h66.373V58.453h-66.373V29.929h75.424V2.41H956.78v140.608h107.203zm168.346 0V2.41h-33.387l-37.009 59.457-37.008-59.457h-33.387v140.608h30.37V51.824l39.22 59.457h.805l39.623-60.06v91.797h30.773zM1390.822 2.41h-35.198l-34.193 56.444-33.588-56.444h-36.204l54.104 85.168v55.44h30.974V86.976l54.105-84.566z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJrAcademyLogo);
export default __webpack_public_path__ + "static/media/jr-academy-logo.7fb14a7bb39e16a67043fa3785352560.svg";
export { ForwardRef as ReactComponent };